import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500">海量漫画资源，多种分类任你选择</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 max-w-[900px] mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl p-6 md:p-8 bg-background-100 hover:bg-primary-50 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative z-10">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500">{cat.description}</p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 font-medium group-hover:gap-2 transition-all whitespace-nowrap">
                  浏览全部
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}